<template>
  <ModalPreviewFile style="display: none" />
  <div class="main">
    <Title title="Entregas" />
    <div class="wrapper-delivery">
      <AdminSelect
        :options="clientList"
        :id="'Clients'"
        v-model:text="client.val"
        :value="client.val"
        :label="'Cliente'"
        :has-error="client.enabled"
        :error="client.errors.length === 0 ? '' : client.errors[0]"
        class="client"
      />
      <div class="form">
        <AdminInput
          v-model:text="name.val"
          :value="name.val"
          :label="'Nombre de la entrega'"
          :has-error="name.enabled"
          :error="name.errors.length === 0 ? '' : name.errors[0]"
        />
        <AdminTextArea
          v-model:text="message.val"
          :value="message.val"
          :label="'Mensaje de la entrega'"
          :has-error="message.enabled"
          :error="message.errors.length === 0 ? '' : message.errors[0]"
        />
        <div class="drag-drop" @dragover.prevent @drop="handleDrop">
          <img
            src="assets/administrator/DragAndDrop.svg"
            alt="Suelta los archivos aquí"
            class="icon"
          />
          <p>Suelta los archivos aquí</p>
        </div>
      </div>

      <div class="files">
        <!-- Archivos Aprobados -->
        <div
          class="wrapper-file approved-files"
          :class="{ 'is-expanded': showApproved }"
        >
          <div class="first-info" @click="toggleSection('approved')">
            <p class="yellow-text">Archivos aprobados</p>
            <div class="info-right">
              <!-- <p class="light-text">{{ approvedFiles.length }}</p> -->
              <p class="light-text">2</p>
              <img
                src="assets/administrator/DownArrow.svg"
                class="arrow-icon"
                :class="{ 'rotate-down': showApproved }"
                alt="Toggle"
              />
            </div>
          </div>
          <div name="slide">
            <ul class="secondary-info" v-show="showApproved">
              <div class="line-container">
                <div class="line"></div>
              </div>
              <li
                class="file-item"
                v-for="(resource, index) in resources"
                :key="index"
              >
                <p class="light-text">{{ resource.name }}</p>
                <p class="light-text center">{{ resource.extension }}</p>
                <p class="light-text center">{{ resource.size }}</p>
              </li>
            </ul>
          </div>
        </div>

        <!-- Archivos Rechazados -->
        <div
          class="wrapper-file rejected-files"
          :class="{ 'is-expanded': showRejected }"
        >
          <div class="first-info" @click="toggleSection('rejected')">
            <p class="yellow-text">Archivos rechazados</p>
            <div class="info-right">
              <!-- <p class="light-text">{{ rejectedFiles.length }}</p> -->
              <p class="light-text">4</p>
              <img
                src="assets/administrator/DownArrow.svg"
                class="arrow-icon"
                :class="{ 'rotate-down': showRejected }"
                alt="Toggle"
              />
            </div>
          </div>

          <div name="slide">
            <ul class="secondary-info" v-show="showRejected">
              <div class="line-container">
                <div class="line"></div>
              </div>
              <li
                class="file-item"
                v-for="(resource, index) in resources"
                :key="index"
              >
                <p class="light-text">{{ resource.name }}</p>
                <p class="light-text center">{{ resource.extension }}</p>
                <p class="light-text center">{{ resource.size }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="buttons">
        <StandardButton
          :buttonLabel="'Cancelar'"
          :isCancel="true"
          @click="backDeliveriesOption"
        />
        <StandardButton
          :buttonLabel="'Guardar'"
          :is-disabled="successForm"
          @click="createDeliveryTransaction"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Title from "../layoutAdmin/components/Title.vue";
import AdminInput from "../../../components/commons/controls/AdminInput.vue";
import AdminTextArea from "../../../components/commons/controls/AdminTextArea.vue";
import AdminSelect from "../../../components/commons/controls/AdminSelect.vue";
import StandardButton from "../../../components/commons/controls/StandardButton.vue";
import ModalPreviewFile from "../createEditDelivery/components/ModalPreviewFile.vue";
import { createEditDeliveryValidator } from "./validators/createEditDeliveryValidator";
import { createEditDeliveryUse } from "./use/createEditDeliveryUse";

export default defineComponent({
  name: "CreateEditDeliveryView",
  components: {
    Title,
    AdminInput,
    AdminTextArea,
    AdminSelect,
    StandardButton,
    ModalPreviewFile,
  },

  setup() {
    const showApproved = ref(false);
    const showRejected = ref(false);
    const activeSection = ref<string | null>(null);

    const { client, name, message, successForm, reset } =
      createEditDeliveryValidator();

    const {
      backDeliveriesOption,
      resources,
      clientList,
      createDeliveryOperation,
    } = createEditDeliveryUse();

    const toggleSection = (section: string) => {
      if (section === "approved") {
        showApproved.value = !showApproved.value;
        showRejected.value = false;
      } else {
        showRejected.value = !showRejected.value;
        showApproved.value = false;
      }
    };

    // async function createDeliveryTransaction() {
    //   await createDeliveryOperation(
    //     client.value.val ?? "",
    //     name.value.val ?? "",
    //     message.value.val ?? "",
    //     null,
    //     null,
    //     deliveryDate
    //   );
    //   backDeliveriesOption();
    // }

    async function uploadFileTransaction(event: Event) {
      const cleanEvent = event.target as HTMLInputElement;
      const file = cleanEvent.files?.[0];

      if (!file) return;
    }

    async function handleDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      const files = event.dataTransfer?.files;
      if (!files || files.length <= 0) {
        return;
      }
    }

    return {
      client,
      name,
      message,
      successForm,
      reset,

      toggleSection,
      backDeliveriesOption,
      resources,
      showApproved,
      showRejected,
      activeSection,
      clientList,
      createDeliveryOperation,
      // createDeliveryTransaction,
      uploadFileTransaction,
      handleDrop,
    };
  },
});
</script>


<style scoped lang="scss">
@import "src/ux/admin/createEditDelivery/styles/createEditDeliveryStyle";
</style>
